import React from 'react';

import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import Box from '@material-ui/core/Box';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

class TreeTableElement extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false
		};
		this.openClose = this.openClose.bind(this);
		this.renderChildren = this.renderChildren.bind(this);
		this.renderTreeCell = this.renderTreeCell.bind(this);
		
	}
	openClose() {
		this.setState((state) => {
			return {
				open: !state.open
			};
		});
	}
	renderChildren() {
		return this.state.open &&
		this.props.element.children.map((child, index) =>
			<TreeTableElement element={child} depth={this.props.depth + 1}/>
		);
	}
	renderTreeCell(content) {
		return (
			<TableCell onClick={this.openClose}>
				<Box ml={this.props.depth * 3} alignItems="center" display="flex">
					{
						(this.props.element.children.length ?
							(this.state.open ? <ExpandMoreIcon/> : <ChevronRightIcon/>)
							: null
						)
					}
					<span>{content}</span>
				</Box>
			</TableCell>
		);
	}
	render() {
		return (
			<>
				<TableRow>
					{Object.entries(this.props.element.data).map((field, index) =>
						{
							if(index === 0) {
								return this.renderTreeCell(field[1]);
							}
							else {
								return (
									<TableCell>
										{field[1]}
									</TableCell>
								);
							}
						}
					)}
				</TableRow>
				{this.renderChildren()}
			</>
		);
	}
}

export default TreeTableElement;